import { CSSProperties, ReactNode, useRef } from 'react'
import css from './dropdown.module.css'
import usePopup from '../../../hooks/usePopup'
import SmoothDropdown from '../../SmoothDropdownBehaivor/SmoothDropdown'
import { ReactComponent as ArrowDown } from '../../../asserts/icons/angleDown.svg'
import CircleLoader from '../../Loaders/CircleLoader'

export interface IOption<T extends string | number> {
  title: string
  value: T
}

interface IProps<T extends string | number> {
  options: IOption<T>[]
  selectedOption: IOption<T>['value']
  title: string | ReactNode
  onSelect: (option: T, name?: string) => void
  name?: string
  loading?: boolean
  style?: CSSProperties
}

const Dropdown = <T extends string | number>(props: IProps<T>) => {
  const ref = useRef<HTMLDivElement>(null)
  const { open, setOpen } = usePopup(ref)

  const handleChange = (optionValue: T) => () => {
    setOpen(false)
    props.onSelect(optionValue, props.name)
  }

  const renderOptions = () => {
    return props.options.map((option) => (
      <span
        className={css.option}
        key={option.value}
        onClick={handleChange(option.value)}
        data-active={option.value === props.selectedOption}
      >
        {option.title}
      </span>
    ))
  }

  const selectedOption = props.options.find((o) => o.value === props.selectedOption)?.title

  return (
    <div
      ref={ref}
      className={css.wrapper}
      data-open={open}
      style={props.style}
      onClick={() => setOpen(!open)}
      title={selectedOption}
    >
      <div data-open={open} className={css.title}>
        {selectedOption ?? props.title}
      </div>
      <div className={css.arrow} data-open={open}>
        {props.loading ? (
          <CircleLoader style={{ width: '20px', height: '20px', margin: 0 }} />
        ) : (
          <ArrowDown width={20} height={20} />
        )}
      </div>
      <SmoothDropdown open={open} className={css.options} maxHeight={300} overflow="auto">
        {renderOptions()}
      </SmoothDropdown>
    </div>
  )
}

export default Dropdown
